// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Text__Jsx3 = require("../../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var PropertyAddressValidationCallout = require("./PropertyAddressValidationCallout.bs.js");

function PropertyMlsValidationStatusComponents$AlreadyOnMlsCannotBeBroadcast(props) {
  return JsxRuntime.jsx(PropertyAddressValidationCallout.make, {
              heading: "This property is already on the MLS",
              children: JsxRuntime.jsx(Text__Jsx3.make, {
                    lineHeight: {
                      NAME: "float",
                      VAL: 1.50
                    },
                    children: JsxRuntime.jsx("p", {
                          children: "This property is already on the MLS and therefore cannot be broadcast on TAN. Please contact us if you have any questions."
                        })
                  }),
              icon: "Warning"
            });
}

var AlreadyOnMlsCannotBeBroadcast = {
  make: PropertyMlsValidationStatusComponents$AlreadyOnMlsCannotBeBroadcast
};

exports.AlreadyOnMlsCannotBeBroadcast = AlreadyOnMlsCannotBeBroadcast;
/* Text__Jsx3 Not a pure module */
